import React from "react";

// Swiss section marker: index numeral + uppercase label on a hairline rule.
function TitleButton({ title, number }) {
  return (
    <div className='flex items-baseline gap-4 border-t border-line pt-4'>
      {number && (
        <span className='font-body text-sm font-medium tabular-nums text-primary/45'>
          {number}
        </span>
      )}
      <span className='font-body text-2xs md:text-xs font-medium uppercase tracking-widest text-primary/55'>
        {title}
      </span>
    </div>
  );
}

export default TitleButton;
